import { qpChangeDomain } from '@library/functions/changeDomain/qp-change-domain';
import { SERVER_API_URL } from '@one/app/app.constants';
import { IQimaConnectAuthenticationResponse, IRefreshTokenResponse } from '@one/app/pages/connect/connect.models';
import { QIMA_CONNECT_CONFIG } from '@one/app/shared/tokens/qima-connect-config.token';
import { WINDOW } from '@one/app/shared/tokens/window.token';
import { Location } from '@angular/common';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConnectService {
  public readonly _httpClient = inject(HttpClient);
  public readonly _qimaConnectConfig = inject(QIMA_CONNECT_CONFIG);
  public readonly _window = inject(WINDOW);
  public readonly _location = inject(Location);

  public retrieveToken$(accessToken: string): Observable<HttpResponse<IQimaConnectAuthenticationResponse>> {
    const headers = new HttpHeaders().append('QConnect-Access-Token', accessToken);

    return this._httpClient.post<IQimaConnectAuthenticationResponse>(`${SERVER_API_URL}/api/auth/qima-connect`, null, {
      observe: 'response',
      headers,
    });
  }

  public logout$(accessToken: Readonly<string>, userName: Readonly<string>): Observable<void> {
    const headers = new HttpHeaders().append('Authorization', `Bearer ${accessToken}`);

    return this._httpClient.post<void>(`${this._qimaConnectConfig.url}/api/v1/auth/sign-out`, { email: userName }, { headers });
  }

  public refreshToken$(clientId: Readonly<string>, sub: Readonly<string>, refreshToken: Readonly<string>): Observable<string> {
    return this._httpClient
      .post<IRefreshTokenResponse>(`${this._qimaConnectConfig.url}/api/v1/auth/refresh`, { clientId, sub, refreshToken })
      .pipe(
        map((response): string => {
          return response.accessToken;
        })
      );
  }

  public redirectToConnectOrNothing(): void {
    if (this._qimaConnectConfig.enabled) {
      let targetUrl = this._qimaConnectConfig.url ?? '';

      if (this._window.origin.endsWith('.cn')) {
        targetUrl = this._qimaConnectConfig.cnUrl ?? qpChangeDomain(targetUrl, '.cn');
      }

      this._window.location.assign(
        `${targetUrl}${this._location.prepareExternalUrl('/login')}?origin=${this._window.location.origin}&redirect=/connect`
      );
    }
  }

  public isEnabled(): boolean {
    return this._qimaConnectConfig.enabled;
  }
}
